<template>
  <div
    v-if="group.hasMessages"
    class="mt-12"
    data-test="payment-group-messages"
  >
    <p
      v-for="message in group.config.messages"
      :key="message.id"
      class="body-2"
    >
      <FormattedMessage :definition="message">
        <template #provider>
          <strong class="body-2-bold">
            {{ group.config.providerName }}
          </strong>
        </template>
      </FormattedMessage>
    </p>
  </div>
</template>

<script lang="ts" setup>
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'

import type { PaymentGroupData } from '../../../methods/config/methods.type'

defineProps<{ group: PaymentGroupData }>()
</script>
